<!--导入库存-->
<template>
    <div class="content-panel">
        <el-row :gutter="10" type="flex" justify="space-between" align="middle" class="breadcrumb-wrap">
            <el-col :span="20">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item :to="{ path: '/' }">{{msg('首页')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{msg('导入库存')}}</el-breadcrumb-item>
                </el-breadcrumb>
            </el-col>
        </el-row> 
        <el-row :gutter="10"  class="ctrl-wrap">
            <el-col :sm="24" :md="18">
                <el-button size="mini"
                    @click="doSelectFile()" type="success" 
                    style="margin-right:5px; margin-bottom:5px;">
                        <i class="iconfont icon-xuanzewenjian" 
                            style="display:inline-block;margin-right:4px;"></i>
                        <transition name="el-fade-in-linear">
                            <span v-show="!isMinScreen">{{msg('上传文件')}}</span>
                        </transition>
                </el-button>
                <div ref="fileArea" style="display:none;">
                </div>
                <el-select v-model="addType" style="margin-bottom:5px;"
                    placeholder="选择新增类型" size="mini" @change="changeStrategy">
                    <el-option
                        v-for="item in importTypes"
                        :key="item.value" 
                        :label="item.label"
                        :value="item.value"> 
                    </el-option>
                </el-select>
                <el-select v-if="addType" v-model="storeId" style="margin-bottom:5px;"
                    placeholder="选择仓库" size="mini" @change="changeStore">
                    <el-option
                        v-for="item in stores"
                        :key="item.id" 
                        :label="item.name"
                        :value="item.id"> 
                    </el-option>
                </el-select>
                <el-select v-if="storeId && addType != 3" v-model="storeType" style="margin-bottom:5px;"
                    placeholder="选择仓储类型" size="mini">
                    <el-option
                        v-for="item in inventoryStoreTypes"
                        :key="item.value" 
                        :label="item.label"
                        :value="item.value"> 
                    </el-option>
                </el-select>
            </el-col>
            <el-col :sm="24" :md="6">
                <el-button type="primary" size="mini" @click="doDownloadDefaultTpl" plain style="margin-bottom:5px;">
                    <i class="el-icon-download" style="display:inline-block;margin-right:4px;"></i>
                    <transition name="el-fade-in-linear">
                        <span v-show="!isMinScreen">{{msg('新增/预报模板')}}</span>
                    </transition>
                </el-button>
                <el-button type="primary" size="mini" @click="doDownloadInventoryTpl" plain style="margin-bottom:5px;">
                    <i class="el-icon-download" style="display:inline-block;margin-right:4px;"></i>
                    <transition name="el-fade-in-linear">
                        <span v-show="!isMinScreen">{{msg('转库存模板')}}</span>
                    </transition>
                </el-button>
            </el-col>
        </el-row>
        <el-row :gutter="15">
            <el-table :data="results" :height="docHeight" style="width: 100%" size="mini" ref="dataTable" stripe>
                <el-table-column type="index" width="50"></el-table-column>
                <el-table-column prop="code" :label="msg('库存编号')" min-width="100" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="qty" :label="msg('件数')" min-width="100" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="shelfCode" :label="msg('架位号')" min-width="100" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="cost" :label="msg('单件成本')" min-width="100" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="sku" :label="msg('SKU')" min-width="100" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="variationSku" :label="msg('货号')" min-width="100" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="spec" :label="msg('规格')" min-width="100" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="title" :label="msg('标题')" min-width="100" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="ownerName" :label="msg('归属人')" min-width="100" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="remark1" :label="msg('备注')" min-width="100" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="remark2" :label="msg('说明')" min-width="100" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="result" :label="msg('上传结果')" min-width="200" :show-overflow-tooltip="true"></el-table-column>
            </el-table>
        </el-row>
    </div>
</template>
<script>
import XLSX from "xlsx";
export default {
    name: 'StockImport',
    components: {},
    data(){
        return {
            addType: null,  //1:预报，2-新增
            storeId: null, //选择仓库
            storeType:null, //选择仓储类型
            excelHeads: [], //从excel解析出数据的表头
            excelData: null, //从excel解析出的数据
            importTemplate: null,
            colNames: [  //字段映射
            ],
            importTypes:[
                {
                    label:this.msg('预报'),
                    value:1
                },
                {
                    label:this.msg('新增'),
                    value:2
                },
                {
                    label:this.msg('转库存'),
                    value:3
                },
            ],
            results:[],
            templates: [],
            stores:null,
            inventoryStoreTypes:[],
        }
    },
    computed: {
        docHeight: {  //表格的高度
            get() {
                var height =  this.$store.state.docHeight;
                return height - 220;
            }
        },
        isMinScreen: {  //是否小屏幕，浏览器
            get() {
                var is = this.$store.state.isMinScreen;
                return is;
            }
        },
    },
    mounted(){
        this.init();
    },
    methods:{
        init(){
            this.addType = null;
            this.storeId = null;
            this.storeType = null;
        },
        getStores(){
            this.$axios.post(this.$kit.api.store.listUsed)
                .then((result)=> {
                    if(result.status){
                        this.stores = result.data;
                    }
                });
        },
        getOwnStores(){
            this.$axios.post(this.$kit.api.store.listByOwn)
                .then((result)=> {
                    if(result.status){
                        this.stores = result.data;
                    }
                });
        },
        doSelectFile(){  //点击选择文件
            this.$refs.fileArea.innerHTML = "";
            var input = document.createElement("input");
            input.type="file";
            var _this = this;
            input.onchange=this.getUploadFile;    
            this.$refs.fileArea.appendChild(input);
            input.click();
        },
        getUploadFile(e) {  //解析上传的excel
            let that = this;
            this.excelData = null
            this.excelName = null
            //拿到所导入文件的名字
            let fileName = e.target.files[0];
            //定义reader，存放文件读取方法
            let reader = new FileReader();
            //启动函数
            reader.readAsBinaryString(fileName)
            //onload在文件被读取时自动触发
            reader.onload = (e) => {
                //workbook存放excel的所有基本信息
                let workbook = XLSX.read(e.target.result, {type: 'binary'})
                //定义sheetList中存放excel表格的sheet表，就是最下方的tab
                let sheetList = workbook.SheetNames
                //存放json数组格式的表格数据
                let worksheet = workbook.Sheets[workbook.SheetNames[0]];
                let json = XLSX.utils.sheet_to_json(worksheet, {header:1})

                var heads = json[0];
                //第0行是表头
                let rows = json.splice(0);
                that.excelData = rows.filter(row => row.length>0);
                that.excelName = fileName.name;
                that.excelHeads = heads;
                that.$refs.fileArea.innerHTML = "";
                this.doUpload();
            };
        },
        changeStrategy(){
            this.storeId = null;
            if(this.addType == 2 && !this.hasPermission('stock:batchFieldStore')){
                this.getOwnStores();
            }else{
                this.getStores();
            }
        },
        changeStore(){
            if(this.storeId){
                this.storeType = null;
                this.inventoryStoreTypes = [];
                this.getStoreTypes();
            }
        },
        getStoreTypes(){
            this.$axios.get(this.$kit.api.store.storeTypes+"?store="+this.storeId)
                .then((result)=> {
                    if(result.status){
                        let data = result.data;
                        if(data && data){
                            let types = data.split(',');
                            types.forEach(e => {
                                let storeType = this.dicts.inventoryStoreTypes.find(d => d.value === +e);
                                this.inventoryStoreTypes.push(storeType);
                            })
                        }else{
                            this.inventoryStoreTypes = [];
                        }
                    }
                });
        },
        doDownloadTpl(){  //下载一个excel模板，
            var selectes = this.$refs.colTable.selection;
            if(selectes.length==0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }
            var selectesTitles = selectes.map(c => c.targetName || c.needName);
            var titles = [selectesTitles, ['','','','','','']];
 
            var filename = this.importTemplate? this.templates.find(t => t.id == this.importTemplate).name+".xlsx" : '模板.xlsx';

            var wb = XLSX.utils.book_new();
            var ws = XLSX.utils.aoa_to_sheet(titles);

            XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
            XLSX.writeFile(wb, filename);
        },
        doDownloadDefaultTpl(){//下载默认模板
            var titles = [['库存编号','件数','架位号','单件成本','SKU','货号','规格','标题','归属人','备注','说明'],
            [],[],[],
            ['说明1：新增库存时，库存编号、件数和架位号为必填项'],
            ['说明2：预报库存时，库存编号和件数为必填项'],
            ['说明3：归属人请填写账号，不填时归属人默认为导入人'],
            ['(导入时说明内容必须删除)']];
 
            var filename = '库存导入模板.xlsx';

            var wb = XLSX.utils.book_new();
            var ws = XLSX.utils.aoa_to_sheet(titles);

            XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
            XLSX.writeFile(wb, filename);
        },
        doDownloadInventoryTpl(){
            var titles = [['订单编号','架位号'],
            [],[],[],
            ['(导入时说明内容必须删除)']];
 
            var filename = '转库存模板.xlsx';

            var wb = XLSX.utils.book_new();
            var ws = XLSX.utils.aoa_to_sheet(titles);

            XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
            XLSX.writeFile(wb, filename);
        },
        doUpload(){

            if(!this.excelData || this.excelData.length == 0){
                this.$message(this.msg('请上传一个内容不为空的excel文件'));
                return;
            }

            if(!this.addType){
                this.$message(this.msg('请选择新增类型'));
                return;
            }

            if(!this.storeId){
                this.$message(this.msg('请选择仓库'));
                return;
            }

            if(!this.storeType && this.addType != 3){
                this.$message(this.msg('请选择仓储类型'));
                return;
            }

            let ok = true;
            let msg = null;
            this.excelData.forEach(e => {
                if(!e[0]){
                    msg = '库存编号不能为空，请检查数据';
                    ok = false;
                    return;
                }
                if(e[3]){
                    e[3] = (e[3]*100).toFixed(0);
                }
            })
            if(!ok){
                this.$message(msg);
                return;
            }

            this.$axios.post(this.$kit.api.inventory.doImport+"?t="+this.addType+"&store="+this.storeId+"&storeType="+this.storeType, 
                this.excelData
            ).then((result) => {
                if(result.status){
                    let data = result.data;
                    this.results = data;
                    if(this.results){
                        this.results.forEach(e => {
                            e.cost = (e.cost/100).toFixed(2);
                        })
                    }
                }else{
                    this.$message(result.msg || this.msg('数据错误，请检查表格数据'));
                }
            });
        },
    }
}
</script>
<style lang="scss" scoped>

</style>